module.exports = __webpack_public_path__ + "img/detail-address.f1bfe37c.svg";